import { POS_ROUTE } from "../../../constants/constants";

export const TAX_INFO_ROUTE = POS_ROUTE + "/tax-info"